import styled from "styled-components";

import FnrShineButton from "./FnrShineButton";
import { ACCENT_COLOR } from "Wizard/theme";

export default function Button({ children, onClick, disabled, iconLeft }) {
  return (
    <Wrapper $accent={ACCENT_COLOR} $disabled={disabled}>
      <FnrShineButton onClick={onClick} disabled={disabled}>
        <Inside $iconLeft={iconLeft}>{children}</Inside>
      </FnrShineButton>
    </Wrapper>
  );
}

const Wrapper = styled.button`
  appearance: none;
  padding: 0;
  margin: 0;
  border: none;
  background: ${(p) => (p.$disabled ? "#d1d5db" : p.$accent)};
  border-radius: 100px;
  transition: background 0.2s;
  pointer-events: ${(p) => (p.$disabled ? "none" : "auto")};
`;
const Inside = styled.div`
  font-size: 28px;
  color: #fff;
  text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px;
  padding: ${(p) => p.$iconLeft ? '12px 24px 12px 12px' : '12px 12px 12px 24px'};
`;
